export const getBaseURL = (): string => {
    // Allow mocking for unit tests.
    if ((window as any).MOCK_BASE_URL) {
        return (window as any).MOCK_BASE_URL;
    }

    const url = location.href;
    const pathname = location.pathname;
    const index1 = url.indexOf(pathname);
    const index2 = url.indexOf("/", index1 + 1);
    const baseLocalUrl = url.substr(0, index2);

    return baseLocalUrl + "/";
};
